<template>
  <div>
    <!--  固定头部-->
    <div class="adbox flex space_between" @click="godown" v-if="!isIos">
      <!--    <img src="../../assets/image/common/banner.png" alt="" style="width: 100%;height: 50px">-->

      <div class="f14 flex" style="width: 75%;background: black;height: 50px;padding-left: 20px">
        <img src="../../assets/logo.png" alt="" style="height: 36px;margin-right: 10px">
        <div class="white_f">
          <p style="font-size: 12px">打开我惠省钱App购物</p>
          <van-divider style="color: #d9d9d9">
            <div slot="default" class="f10" style="font-size: 10px">少花钱 &nbsp; 多省钱</div>
          </van-divider>
        </div>
      </div>
      <div class="white_f setmid f14" style="height: 50px;width: 25%;background: #e53737;font-size: 14px">立即下载</div>
    </div>

    <div class="top" :style="{'background-color': color, 'top': isIos?'0': '50px'}">
      <van-search
        v-model="value"
        placeholder="请输入关键词搜索"
        readonly
        show-action
        shape="round"
        :background="color"
        @click="toSearch"
      >
        <div class="setmid" slot="action" >
<!--          <img @click="pushTo('/nearshop')" style="margin-right: .1rem;" class="mes" src="../../assets/image/common/shangquan.png" alt="">-->
          <img @click="showMes" class="mes" src="../../assets/image/common/xiaoxi_kong.png" v-if="info.isMsg" alt="">
          <img @click="showMes" class="mes" src="../../assets/image/common/xiaoxi.png" v-else alt="">
        </div>
      </van-search>
    </div>
    <div class="more flex main_bg space_around" id="tabitem" :style="{top: isIos?'50px':'100px'}" @click="pushTo('/Items')">
      <img src="../../assets/image/common/fenlei.png" alt="" style="width: .4rem">
      <span class="white_f" style="display: inline-block;width: .8rem">分类</span>
    </div>
    <div class="flex space_around tabs">
      <van-tabs
        style="width: 100%"
        v-model="activeIndex"
        :background="color"
        color="#ffffff"
        title-active-color="#ffffff"
        title-inactive-color="#ffffff"
        :border="false"
        :ellipsis="false"
        sticky
        :swipe-threshold="5"
      >
        <van-tab v-for="(item,index) in tabs" :key="index" :title="item.name" swipeable>
          <keep-alive>
            <div :ref="`child${index}`" :is="index<=2?coms[index]:coms[2]" :id="item.id" :info="info" @getinfo="getinfo"></div>
          </keep-alive>
        </van-tab>
        <van-tab v-for="(item,index) in tabs2" :key="index+2" :title="item.name" swipeable>
          <keep-alive>
            <div :ref="`child${index+2}`" :is="coms[2]" :id="item.id" :info="info" @getinfo="getinfo" :uptab="tabs2[index]"></div>
          </keep-alive>
        </van-tab>
        <div slot="nav-right">
          <span class="white_f" style="display: inline-block;width: 1.5rem"></span>
        </div>
      </van-tabs>
    </div>
    <div class="blank"></div>

  </div>
</template>

<script>
  import fine from './fine'
  import secondHome from '../secondHome'
  import secondTab from './secondTab'
  import top100 from './top100'
  import { indexInfo, findAmoyCategory } from '../../api/home'
  import { personalCenterInfo } from '../../api/my'
  import { getHdongUrl } from '../../api/third'
  export default {
    name: 'home',
    components: {
      fine,
      top100,
      secondHome,
      secondTab
    },
    data () {
      return {
        coms: ['fine', 'top100', 'secondHome'],
        tabs: [
          {name: '精选', value: '1'},
          {name: 'TOP100', value: '1'}
        ],
        tabs2: [
        ],
        value: '',
        activeIndex: 0,
        active: 'fine',
        show: false,
        downApp: false,
        color: window.g.main_color,
        ScrollTop: 0,
        info: {},
        userinfo: {}
      }
    },
    mounted () {

    },
    //过滤器
    filters: {
      toInt(value){
        return parseInt(value);
      }
    },
    created () {
      this.getinfo()
      this.findAmoyCategory()
      if(localStorage.getItem('uid')){
        this.getUserinfo()
      }

    },
    // watch: {
    //   '$route'(to, from) {
    //     this.$router.go(0);
    //   }
    // },
    activated () {
      if (this.isAndroid()) {
        let last = this.$store.state.showDown
        let time = new Date().getTime()
        if (!last || (last && (time - last) > 60 * 5 * 1000)) {
          this.downApp = true
          this.$store.commit('saveshowDown', 0)
        }
      }
      this.$store.commit('saveNavIndex', 0)
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.$nextTick(
          function () {
            console.log(vm.$refs)
            console.log(vm.$refs['child' + vm.activeIndex][0])
            // vm.$refs['child' + vm.activeIndex][0].$refs.mescroll && vm.$refs['child' + vm.activeIndex][0].$refs.mescroll.mescroll.setScrollTop(vm.ScrollTop) // 进入路由时,滚动到原来的列表位置,恢复回到顶部按钮和isBounce的配置
            vm.$refs['child' + vm.activeIndex][0].$refs.mescroll && vm.$refs['child' + vm.activeIndex][0].$refs.mescroll.beforeRouteEnter() // 进入路由时,滚动到原来的列表位置,恢复回到顶部按钮和isBounce的配置
          }
        )
      })
    },
    beforeRouteLeave (to, from, next) { // 如果没有配置回到顶部按钮或isBounce,则beforeRouteLeave不用写
      // 找到当前mescroll的ref,调用子组件mescroll-vue的beforeRouteLeave方法
      this.$refs['child' + this.activeIndex][0].$refs.mescroll && this.$refs['child' + this.activeIndex][0].$refs.mescroll.beforeRouteLeave() // 退出路由时,记录列表滚动的位置,隐藏回到顶部按钮和isBounce的配置
      next()
    },
    watch: {
      activeIndex (val, oldval) {
        // console.log(this.$refs['child' + oldval][0].mescroll)
        this.$refs['child' + oldval][0].mescroll.hideTopBtn(0.5)
        // this.$refs['child' + oldval][0].$refs.mescroll.hideTopBtn(0.5)
        this.$store.commit('savehomeIndex', val)
      }
    },
    methods: {
      // 个人中心信息
      getUserinfo () {
        let data = {
          uid: localStorage.getItem('uid')
        }
        personalCenterInfo(data).then(res => {
          if (res.result === '0') {
            this.userinfo = res
            localStorage.setItem('userinfo', JSON.stringify(res))
          }
        })
      },
      goTianmaoZhc(){
        let data = {
          uid: localStorage.getItem('uid'),
          promotion_scene_id: '20150318020001156'
        }
        getHdongUrl(data).then(res =>{
          if (res.result === '0') {
            if(res.status === '0'){
              window.location.href = res.hDongUrl
            }else {
              // 获取淘宝渠道id
              if (this.isWx()) {
                this.$dialog.alert({
                  title: '提示',
                  message: '您是首次使用我惠省钱平台，为保证您的权益，请你点击右上角的“...”,选择“在浏览器中打开”进行下单。',
                  confirmButtonColor: this.m_color
                }).then(() => {
                })
              } else {
                let backurl = window.g.BeforeURL
                window.location.href = window.g.toBind + backurl
              }
            }
          }else {
            this.showToast(res.resultNote)
          }

        })
      },
      // 首页数据
      getinfo () {
        let data = {
          uid: localStorage.getItem('uid'),
          type: 'app'
        }
        indexInfo(data).then(res => {
          if (res.result === '0') {
            this.info = res
            localStorage.setItem('isBindTb', res.isBindTb)
            localStorage.setItem('relation_id', res.relation_id)
          }
        })
      },
      // 跳转消息页
      showMes () {
        if (!localStorage.getItem('uid')) {
          this.$router.push('/login')
        } else {
          this.$router.push({path: '/message'})
        }
      },
      // 获取淘客一二级分类
      findAmoyCategory () {
        findAmoyCategory({}).then(res => {
          if (res.result === '0') {
            this.tabs2 = res.dataList
            this.activeIndex = this.$store.state.homeIndex
          }
        })
      },
      toSearch () {
        this.$router.push('/searchList')
      },
      godown () {
        // this.$router.push('/NewRegist')
        window.location.href=window.g.appDownUrl
      },
      pushTo (url) {
        this.$router.push(url)
      },
      openApp () {
        var iFrame
        iFrame = document.createElement('iframe')
        iFrame.setAttribute('src', window.g.andriodUrl)
        iFrame.setAttribute('style', 'display:none;')
        iFrame.setAttribute('height', '0px')
        iFrame.setAttribute('width', '0px')
        iFrame.setAttribute('frameborder', '0')
        document.body.appendChild(iFrame)
        // 发起请求后这个 iFrame 就没用了，所以把它从 dom 上移除掉
        iFrame.parentNode.removeChild(iFrame)
        iFrame = null
        // window.location.href = window.g.andriodUrl
      },
      // godownApp () {
      //   window.location.href = window.g.appDownUrl
      // },
      close () {
        this.downApp = false
        let time = new Date().getTime()
        this.$store.commit('saveshowDown', time)
      }
    }
  }
</script>

<style scoped>
  .adbox{
    height: 50px;/*no*/
    /*padding: 0 4%;*/
  }
  .adbox .btn{
    padding: 2px 8px;
    border-radius: 4px;
    box-shadow:1px 2px 10px 0px rgba(255,66,66,0.46);
  }
  .mes{
    width: 20px;
  }
  .top{
    position: fixed;
    /*top: 36px;!*no*!*/
    left: 0;
    width: 100%;
    z-index: 99;
    background: white;
  }
  #tabitem{
    position: absolute;
    /*top: 86px;!*no*!*/
    right: 0;
    width: 1.5rem;
    height: 44px;/*no*/
    z-index: 99;
    padding-left: .2rem;
  }
  .top,.blank{
    /*height: 100px;*/
  }
  .tabs{
    padding-top: 50px;/*no*/
    justify-content: space-around;
    align-items: center;
    position: relative;
    z-index: 9;
  }
  /deep/ .van-ellipsis{
    line-height: 44px;
  }
  .top .more{
    align-items: center;
    justify-content: center;
  }
  .fixadd{
    position: fixed;
    right: .2rem;
    top: 60%;
    z-index: 99;
  }
  .close{
    position: absolute;
    right: 0;
    top: -.4rem
  }
  /deep/ .van-divider{
    margin: 0;
    line-height: 1.5
  }
  /deep/ .van-divider--content-center::before, .van-divider--content-left::before, .van-divider--content-right::before{
    margin-right: 6px;
  }
  /deep/ .van-divider--content-center::after, .van-divider--content-left::after, .van-divider--content-right::after {
    margin-left: 6px;
    content: '';
  }
  .HBform{
    width: 90%;
    height: auto;
    /*min-height: 9rem!important;*/
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: top center;
    padding: 13% 11% 7% 11%;
    margin: 0 5%;
  }
  .HBformitem{
    width: 100%;
    padding: 0.2rem 0;
    /*border-bottom: 1px dashed #fff;*/
  }
  .HBgrouw{}
  .HBgrouw .bg{
    margin: 2% 0;
    height: .2rem;
    background-color: rgba(255,255,255,0.4);
    position: relative;
    border-radius: 0.1rem;
  }
  .HBgrouw .bg3{
    /*background:#fcf3d2;*/
    border-radius: 0.1rem;
    color: #333;
    width: 100%;
    font-size: 0.32rem;
    height: auto;
    min-height: 4.7rem !important;
    line-height: 0.67rem;
    text-align: left;
    padding: 0 0.7rem 1.8rem 0.7rem;
    text-indent: 2em; /*em是相对单位，2em即现在一个字大小的两倍*/
  }
  .HBgrouw .val{
    position: absolute;
    left: 0;
    text-outline: 0;
    height: 100%;
  }
  .HBmainbg{
    background-color: rgba(255,255,255,1);
    border-radius: 0.1rem;
  }
  .btngoxf{
    width: 80%;
    /*display: flex;*/
    /*justify-content: center;*/
    align-items: center;
    line-height: 1.4rem;
    text-align: center;
    background: url("../../assets/image/common/xftbPopupBtn.png") center top no-repeat;
    background-size: 100%;
    color: #8e4d0b;
    margin: 0 10%;
    padding: 0;
  }
  .btn-HB-Close{
    width: 100%;
    height: auto;
    margin: 0.4rem 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/home/home.vue